import { Col, Modal, Row } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../UI/Title/Title";
import { UsersListModal } from "./UserListModal";
import { useState } from "react";
import ResetButton from "../../UI/ResetButton/resetbutton";
import { Search } from "../../UI/Search/Search";

type PropsType = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  users: any;
  isLoading: boolean;
};

const UsersForRole = ({ isOpen, setIsOpen, users, isLoading }: PropsType) => {
  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
  };
  const [, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(1000);
  const { t } = useTranslation("common");
  return (
    <Modal
      centered
      maskClosable={false}
      closable={false}
      width={800}
      okText={`${t("confirm")}`}
      okButtonProps={{ style: { display: "none" } }}
      cancelText={`${t("cancel")}`}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      cancelButtonProps={{
        style: {
          color: "#1677FF",
          border: "1px solid #1677FF",
          height: "40px",
          width: "100px",
        },
      }}
    >
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <Title title={`${t("permissions")}`} />
        </Col>

        <Col span={24}>
          {" "}
          <span className="modaltitleEdit">
            {t("list-of-users-for-role")} {""}
            {"ha"}
          </span>
        </Col>

        <Col span={8}>
          <Search value={""} onKeyPress={""} onChange={""} />
        </Col>

        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
        </Col>
        <Col span={24}>
          <UsersListModal
            users={users}
            loading={isLoading}
            tableKey={tableKey}
          />
        </Col>
      </Row>
    </Modal>
  );
};

export default UsersForRole;
